import { PushNotifications } from '@capacitor/push-notifications';
import { Device } from '@capacitor/device';
import { Preferences } from '@capacitor/preferences';

import api from './helpers/http';
import { navigateFromPush } from './helpers/pushNavigation';

let listenersAttached = false;

export const sendPushTokenToBackend = async (pushToken: string, accessToken: string) => {
  if (!pushToken || !accessToken) {
    return;
  }
  try {
    await api.post('/auth/push-token', { pushToken }, { headers: { 'x-access-token': accessToken } });
    console.info('[PUSH] Token synced to backend');
  } catch (e: any) {
    const status = e?.response?.status;
    if (status === 404) {
      console.error('[PUSH] /auth/push-token endpoint not found on backend');
    } else {
      console.error('[PUSH] Failed to sync token to backend: ', e);
    }
  }
};

export const setPushToken = async (token: string) => {
  try {
    const info = await Device.getInfo();
    if (info.platform !== 'web') {
      await Preferences.set({
        key: 'x-push-notifications-token',
        value: JSON.stringify({ token, timestamp: Date.now() }),
      });
    }
  } catch (e) {
    console.error('ERROR ON SET TOKEN:: ', e);
  }
};

export const getPushToken = async () => {
  try {
    const info = await Device.getInfo();
    if (info.platform !== 'web') {
      const ret: any = await Preferences.get({ key: 'x-push-notifications-token' });
      if (!ret?.value) {
        return '';
      }
      return JSON.parse(ret.value) || '';
    }
  } catch (e) {
    console.error('ERROR ON GET TOKEN:: ', e);
    return '';
  }
};

export const setupPushListeners = async () => {
  if (listenersAttached) {
    return;
  }
  const info = await Device.getInfo();
  if (info.platform === 'web') {
    return;
  }
  listenersAttached = true;

  await PushNotifications.addListener('registration', async (token) => {
    if (token?.value) {
      await setPushToken(token.value);
    }
    console.info('[PUSH] Registration token: ', token?.value);
  });

  await PushNotifications.addListener('registrationError', (err) => {
    console.error('[PUSH] Registration error: ', err.error);
  });

  await PushNotifications.addListener('pushNotificationReceived', (notification) => {
    console.info('[PUSH] Notification received: ', notification);
  });

  await PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
    console.info('[PUSH] Notification action performed: ', action.actionId, action.inputValue);
    navigateFromPush(action?.notification?.data);
  });
};

export const registerPushDevice = async () => {
  const info = await Device.getInfo();
  if (info.platform === 'web') {
    return;
  }

  try {
    let permStatus = await PushNotifications.checkPermissions();

    if (permStatus.receive === 'prompt') {
      permStatus = await PushNotifications.requestPermissions();
    }

    if (permStatus.receive !== 'granted') {
      console.error('[PUSH] Notification permission not granted');
      return;
    }

    await PushNotifications.register();
  } catch (e) {
    console.error('[PUSH] Error registering device: ', e);
  }
};
